import React, { useState } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import { FaTooth, FaEdit, FaStickyNote } from "react-icons/fa";
import { Button, Input } from "../../components/Form";
import Modal from "../../components/Modals/Modal";
import { FaSave } from "react-icons/fa";

function SingleTask() {
	const [modal, setModal] = useState(false);
	const [form, setForm] = useState();

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	}

	const handleSubmit = () => {
		setModal(false);
		// Form submission
		// console.log(form);
		setForm(null);
	}
	
	return (
		<Layout>
			<Container className="flex flex-col min-w-80 max-w-80 px-5 py-10 items-center bg-white/60 rounded-lg">
				<FaStickyNote size={44} className="text-gray-900/85" />
				<div className="text-lg my-1">{form?.name ?? 'Name'}</div>
				<div className="text-xs mt-1">Price rate:</div>
				<div className="text-xs mb-4">{form?.price ?? '1.00'} BAM</div>
				<Button
					className="flex max-w-fit px-4 items-center"
					Icon={() => <FaEdit size={16} />}
					label={"Edit"}
          onClick={() => setModal(true)}
				/>
				<Modal isOpen={modal} closeModal={() => setModal(false)} title={"Edit Task"}>
					<Input label={"Name *"} placeholder={"Metal ceramic, Zirconia, ..."} name={"name"} color value={form?.name} onChange={handleChange} />
					<Input label={"Price (BAM)"} placeholder={"Price"} color type={"number"} name={"price"} min={0} value={form?.price} onChange={handleChange} />
					<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSubmit} />
				</Modal>
			</Container>
		</Layout>
	);
}

export default SingleTask;
